import { render } from "./publicClientComponent.vue?vue&type=template&id=455c98b8&scoped=true"
import script from "./publicClientComponent.vue?vue&type=script&lang=js"
export * from "./publicClientComponent.vue?vue&type=script&lang=js"

import "./publicClientComponent.vue?vue&type=style&index=0&id=455c98b8&lang=less"
import "./publicClientComponent.vue?vue&type=style&index=1&id=455c98b8&lang=css"
import "./publicClientComponent.vue?vue&type=style&index=2&id=455c98b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455c98b8"]])

export default __exports__